import type { MeshData } from "@earthbrain/foundation-excavation-sdk";
import type { IGeometry } from "earthbrain-viewer";

export function meshDataToFlat(mesh: Readonly<MeshData>): IGeometry {
	return {
		vertices: Array.from(mesh.positions),
		indices: Array.from(mesh.indices),
	};
}
